import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="privacy-policy-page" className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-500 mb-8 transition-colors" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Privacy Policy</h1>
        <p className="text-sm text-slate-400 mb-12">Last updated: February 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-sm leading-relaxed text-slate-600">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">1. Introduction</h2>
            <p>SkillsimAI ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website skillsimai.com and use our AI-powered soft skills training platform.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li><strong>Personal Information:</strong> Name, email address, company name, and any other information you provide through our contact forms.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our platform, including simulation sessions, performance scores, and conversation logs.</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Provide and improve our AI training services</li>
              <li>Personalize your training experience</li>
              <li>Communicate with you about our services, updates, and offers</li>
              <li>Analyze usage patterns to improve our platform</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">4. Data Sharing</h2>
            <p>We do not sell your personal information. We may share your data with trusted third-party service providers who assist us in operating our platform, conducting our business, or serving our users, so long as those parties agree to keep this information confidential.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">5. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">6. Your Rights</h2>
            <p>Under applicable data protection laws (including GDPR), you have the right to access, correct, delete, or restrict processing of your personal data. To exercise these rights, please contact us at info@skillsimai.com.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">7. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-2">
              SkillsimAI<br />
              1 Canada Square, Canary Wharf<br />
              London E14 5AB, UK<br />
              Email: info@skillsimai.com<br />
              Phone: +44 20 3059 3450
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
